import axios from "axios";
import { retornaParm } from "./../tools/auxiliar";

const basic = `Basic ${retornaParm()}`;

const api = axios.create({
  //baseURL: process.env.BACKEND_URI,
  //baseURL: "http://h-participacao-social.ana.gov.br"
  //baseURL: "http://localhost:8080",
  baseURL: process.env.BACKEND_URI,
  headers: {
    Authorization: `${basic}`
  }
});

export default api;
